import { z } from "zod"
import { ServiceAction } from "../service-part-action"

export const UpdatePartAvailableActionsSchema = z.object({
  availableActions: z.array(z.nativeEnum(ServiceAction)),
})

export type UpdatePartAvailableActions = z.infer<
  typeof UpdatePartAvailableActionsSchema
>
